import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Container, TextField, Button, Typography, Link, Box } from "@mui/material";
import useAuth from "../../hooks/useAuth";

const LoginPage = () => {
  const emailRef = useRef(null);
  const passwordRef = useRef(null); 
  const [error, setError] = useState("");
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleLoginSubmit = async (event) => {
    event.preventDefault();
    const email = emailRef.current.value;
    const password = passwordRef.current.value;
    try {
      console.log(email, password);
      await login(email, password); 
      setError(""); 
      navigate("/profil"); 
    } catch (err) {
      setError("Giriş yapılamadı. Lütfen bilgilerinizi kontrol ediniz.");
      console.error("Login error:", err);
    }
  };

  return (
    <Container maxWidth="xs" sx={{ mt: 8 }}>
      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", padding: 3 }}>
        <Typography variant="h5" sx={{ marginBottom: 3 }}>
          Giriş Yap
        </Typography>
        <form onSubmit={handleLoginSubmit} style={{ width: "100%" }}>
          <TextField
            label="Email"
            type="email"
            variant="outlined"
            fullWidth
            inputRef={emailRef} 
            sx={{ mb: 2 }}
          />
          <TextField
            label="Şifre"
            type="password"
            variant="outlined"
            fullWidth
            inputRef={passwordRef} 
            sx={{ mb: 2 }}
          />
          {error && (
            <Typography color="error" variant="body2" sx={{ mb: 2 }}>
              {error}
            </Typography>
          )}
          <Button type="submit" variant="contained" fullWidth sx={{ mb: 2 }}>
            Giriş Yap
          </Button>
          <Link
            href="/forgot-password"
            variant="body2"
            sx={{ display: "block", textAlign: "center", marginBottom: 2 }}
          >
            Şifrenizi mi unuttunuz?
          </Link>
          <Link href="/kayit-ol " variant="body2" sx={{ display: "block", textAlign: "center" }}>
            Hesabınız yok mu? Kayıt ol!
          </Link>
        </form>
      </Box>
    </Container>
  );
};

export default LoginPage;
